module.exports = __webpack_public_path__ + "img/2D-map-cropped.34b2db5.png";